import script from "./Suggest.vue?vue&type=script&setup=true&lang=js"
export * from "./Suggest.vue?vue&type=script&setup=true&lang=js"

import "./Suggest.vue?vue&type=style&index=0&id=521655ce&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521655ce"]])

export default __exports__